import activity from './activity';
import address from './address';
import afterSale from './after-sale';
import commodity from './commodity';
import coupon from './coupon';
import login from './login';
import matomo from './matomo';
import modal from './modal';
import mp from './mp';
import order from './order';
import outsideComein from './outside-comein';
import placeOrder from './placeOrder';
import price from './price';
import resource from './resource';
import search from './search';
import sku from './sku';
import user from './user';

export const businessUtils = {
  matomo,
  modal,
  order,
  mp,
  outsideComein,
  login,
  resource,
  sku,
  search,
  coupon,
  address,
  afterSale,
  commodity,
  activity,
  placeOrder,
  price,
  user,
};
